import React from 'react'
import PropTypes from 'prop-types'
import ImageContent from '../../components/ui/dataEntry/other/ImageContent'
// import LoadingButton from '../../components/ui/general/buttons/LoadingButton'
// import { utilityService } from '../../services/UtilityService'
import { isEmpty } from 'lodash'
import { Empty } from 'antd'
import './FileTypeImages.scss'

const parentCompoent = 'asset-container'

const FileTypeImages = ({
  images,
  onChangeDefaultImage,
  onCloseImage,
  showEditImage,
  isUpdateImageDisabled,
  mediaCategoryList,
  handleAssetImageCategoryChange,
  isLoading,
  openEditAssetFileModal
  // onImageTypeChange,
  // activeImageType,
}) => {
  return (
    <div className='file-type-image'>
      {
        !isEmpty(images)
          ? images.map(image => {
            return (
              <ImageContent
                key={image.id}
                mediaId={image.id}
                imageDetails={image}
                id={image.id}
                isAssetList
                isDefaultImage={image.isDefault === 'true'}
                makeDefaultImage={onChangeDefaultImage}
                name={image?.fileName || ''}
                imageUrl={image.url}
                onCloseContent={() => onCloseImage(image.id)}
                parentCompoent={parentCompoent}
                showEditImage={showEditImage}
                isUpdateImageDisabled={isUpdateImageDisabled}
                aspectRatio={image.aspectRatio}
                mediaCategoryList={mediaCategoryList}
                handleAssetImageCategoryChange={handleAssetImageCategoryChange}
                isFileType
                isUploading={isLoading}
                openEditAssetFileModal={openEditAssetFileModal}
                fileId={image?.fileId}
              />
            )
          })
          : <Empty description='No files added' />
      }

    </div>
  )
}

FileTypeImages.propTypes = {
  /** images of AssetImages. */
  images: PropTypes.array,
  /** default image of AssetImages. */
  defaultMedia: PropTypes.object,
  /** default image change action callback of AssetImages. */
  onChangeDefaultImage: PropTypes.func,
  /** close image action callback of AssetImages. */
  onCloseImage: PropTypes.func,
  /** close image action callback of AssetImages. */
  showAddImages: PropTypes.func,
  /** edit image action callback of AssetImages. */
  showEditImage: PropTypes.func,
  /** Boolean to disable button */
  isButtonDisabled: PropTypes.bool
}

export default FileTypeImages
